import { render, staticRenderFns } from "./HiredSwitch.vue?vue&type=template&id=7b86a957&scoped=true"
import script from "./HiredSwitch.vue?vue&type=script&lang=ts"
export * from "./HiredSwitch.vue?vue&type=script&lang=ts"
import style0 from "./HiredSwitch.vue?vue&type=style&index=0&id=7b86a957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86a957",
  null
  
)

export default component.exports